import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Form } from "react-form";
import { map } from "lodash";
import ReactPaginate from "react-paginate";
import moment from "moment";
import Dialog from "../UI/Dialog";
import TextFields from "../UI/TextFiled";
import DatePickerUI from "../UI/DatePicker";
import { connect } from "react-redux";

import {
  getFinanceSingleDriver,
  getReportsSingleDriverFinance,
  getSearchFinanceSingleDrivers,
  downloadFinanceSingleDriver
} from "../../store/actions/financeDrivers";
import { createDriversSettlement } from "../../store/actions/reportsSettlement";
import validtaeSettlment from "./validateSettlment";

const DriverInfoRow = props => (
  <div className="col-xs-2">
    <p className="font-sm color-grey50">{props.label}</p>
    <p className="color-primary mt-5">{ props.value }</p>
  </div>
);

class FinanceSingleDrivers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newSettlement: false,
      dateFrom: null,
      dateTo: null,
      reportsLength: 0,
      disabled: true,
      errors: "",
      amountChange: null,
      settlements: {
        driver_id: this.props.match.params.id
      }
    };
  }

  async componentDidMount() {
    const id = this.props.match.params.id;
    this.props.getFinanceSingleDriver(this.props.auth.token, id);
    await this.props.getReportsSingleDriverFinance(
      this.props.auth.token,
      id,
      1
    );
    let reportsShow = [];
    map(this.props.financeDrivers.reportsSingleFinanceDriver, data => {
      reportsShow.push(data);
    });
    if (this.state.reportsLength <= reportsShow.length) {
      this.setState({ reportsLength: reportsShow.length });
    }
  }
  async componentDidUpdate(prevProps, prevState) {
    if (prevState.amountChange !== this.state.amountChange) {
      const id = this.props.match.params.id;
      await this.props.getReportsSingleDriverFinance(
        this.props.auth.token,
        id,
        1
      );
    }
  }
  handleInput = async e => {
    if (e.target.name === "amount") {
      const errors = validtaeSettlment(
        e.target.value,
        this.props.financeDrivers.singleFinanceDriver.purse
      );
      await this.setState({
        errors,
        settlements: {
          ...this.state.settlements,
          [e.target.name]: e.target.value
        },
        disabled: errors ? true : false
      });
    } else {
      this.setState({
        ...this.state,
        settlements: {
          ...this.state.settlements,
          [e.target.name]: e.target.value
        },
        disabled: false
      });
    }
  };

  dateFrom = async (lag, date) => {
    if (lag === "From") {
      await this.setState({
        dateFrom: moment(date).format("YYYY-MM-DD")
      });
    } else if (lag === "To") {
      await this.setState({
        dateTo: moment(date).format("YYYY-MM-DD")
      });
    }
    this.props.getSearchFinanceSingleDrivers(
      this.props.auth.token,
      this.props.match.params.id,
      this.state.dateFrom,
      this.state.dateTo
    );
  };
  onDownload = async () => {
    const response = await this.props.downloadFinanceSingleDriver(
      this.props.auth.token,
      this.props.match.params.id,
      this.state.dateFrom,
      this.state.dateTo
    );
    const url = window.URL.createObjectURL(new Blob([response.payload]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Driver_finance.csv");
    link.click();
  };
  createSettlement = async () => {
    const data = {
      agreed_deposit: this.state.settlements.agreed_deposit,
      amount: this.state.settlements.amount,
      driver: this.props.match.params.id,
      is_deleted: false
    };

    await this.props.createDriversSettlement(this.props.auth.token, data);

    this.setState({
      newSettlement: false,
      amountChange: this.state.settlements.amount
    });
  };
  render() {
    const driver = { ...this.props.financeDrivers.singleFinanceDriver };
    const reports = {
      ...this.props.financeDrivers.reportsSingleFinanceDriver
    };
    const reportsPage = map(reports.results, data => data);
    let currentReportsCount =
      this.state.reportsLength > 0
        ? this.state.reportsLength
        : reportsPage.length;
    let pageCount = Math.ceil(reports.count / currentReportsCount);

    return (
      <React.Fragment>
        <div className="page-title">
          <div className="container">
            <div className="row flex-center-y justify-between">
              <div className="col-xs-9">
                <h1 className="color-grey">Single Driver</h1>
              </div>
              <div className="col-xs-3 text-right">
                <Link
                  onClick={() => this.setState({ newSettlement: true })}
                  to="#"
                  className="btn filled primary min-180"
                >
                  <i className="fa fa-plus font-sm mr-10" />
                  New Settlement
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="container box py-15">
          <div className="row justify-between w-800">
            <DriverInfoRow label="Driver ID" value={driver.id} />
            <DriverInfoRow
              label="Driver Name"
              value={driver.first_name + " " + driver.last_name}
            />
            <DriverInfoRow
              label="Driver Mobile Number"
              value={driver.mobile_number}
            />
            <DriverInfoRow
              label="Agreed Deposit"
              value={driver.agreed_deposit + " SAR"}
            />
            <DriverInfoRow
              label="Pending Amount"
              value={`${Number(driver.purse).toFixed(2)} SAR`}
            />
          </div>

          <Form onSubmit={this.submitted}>
            {formApi => (
              <form onSubmit={formApi.submitForm} className="mt-35">
                <div className="row">
                  <div className="col-xs-2">
                    <DatePickerUI
                      label="From"
                      hintText="From"
                      dateFrom={this.dateFrom}
                    />
                  </div>
                  <div className="col-xs-2 ml-30">
                    <DatePickerUI
                      label="To"
                      hintText="To"
                      dateFrom={this.dateFrom}
                    />
                  </div>
                </div>
              </form>
            )}
          </Form>

          <div className="table mt-20">
            <table>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Driver ID</th>
                  <th>Amount Collected From Users</th>
                  <th>Amount Paid to The Restaurants</th>
                </tr>
              </thead>
              <tbody>
                {map(reports.results, (row, i) => (
                  <tr key={i}>
                    <td>{row.days}</td>
                    <td>{driver.id}</td>
                    <td>{row.amount_collected_from_users} SAR</td>
                    <td>{row.amount_paid_to_restaurant} SAR</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="flex-center-y justify-between mt-20">
            <Link
              to={`/finance/settlements/${this.props.match.params.id}`}
              className="font-sm w-800 underline"
            >
              Settelments >>
            </Link>
            {pageCount > 0 && (
              <ReactPaginate
                onPageChange={this.handleClick}
                pageCount={pageCount}
                initialPage={0}
                breakClassName={"break-me"}
                containerClassName={"pagination"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
                previousLabel={<i className="fa fa-chevron-left" />}
                nextLabel={<i className="fa fa-chevron-right" />}
              />
            )}
            <Link
              to="#"
              className="flex-align-y font-sm w-800"
              onClick={this.onDownload}
            >
              <i className="fa fa-download mr-10" />
              Download Excel File
            </Link>
          </div>
        </div>
        {/* START: Create New Settlement Popup */}
        <Dialog
          open={this.state.newSettlement}
          handleClose={() => this.setState({ newSettlement: false })}
        >
          <div className="popup-title no-driver">
            <h2>New Settlement</h2>
          </div>

          <div className="popup-body pb-30">
            <Form onSubmit={this.submitted}>
              {formApi => (
                <form
                  onSubmit={formApi.submitForm}
                  onChange={this.handleInput}
                  onBlur={e => {
                    if (e.target.name === "amount") {
                      const errors = validtaeSettlment(
                        e.target.value,
                        this.props.financeDrivers.singleFinanceDriver.purse
                      );
                      this.setState({
                        errors
                      });
                    }
                  }}
                >
                  <TextFields
                    label="Amount Settlements"
                    name="amount"
                    value={this.state.settlements.amount}
                  />
                  {this.state.errors &&
                    this.state.errors.length > 0 && (
                      <div style={{ color: "red" }}>{this.state.errors}</div>
                    )}
                  {/* <TextFields label="Agreed Deposit" name="agreed_deposit" /> */}
                </form>
              )}
            </Form>
          </div>

          <div className="popup-meta flex justify-end">
            <button
              className="no-style w-600 pointer mx-20"
              onClick={() => this.setState({ newSettlement: false })}
            >
              Cancel
            </button>
            <button
              className="btn filled primary min-120"
              onClick={this.createSettlement}
              disabled={this.state.disabled}
            >
              Submit
            </button>
          </div>
          <button
            className="no-style close-btn"
            onClick={() => this.setState({ newSettlement: false })}
          >
            ×
          </button>
        </Dialog>
        {/* END: Create New Settlement Popup */}
      </React.Fragment>
    );
  }
}
function mapStateToProps(state) {
  return {
    financeDrivers: state.financeDrivers,
    auth: state.auth
  };
}
export default connect(
  mapStateToProps,
  {
    getFinanceSingleDriver,
    getReportsSingleDriverFinance,
    getSearchFinanceSingleDrivers,
    downloadFinanceSingleDriver,
    createDriversSettlement
  }
)(FinanceSingleDrivers);



// WEBPACK FOOTER //
// ./src/components/Finance/SingleDriver.js